import { Settings } from "lucide-react";
import { useWorkspace } from "../../store/WorkspaceContext";
import { DEFAULT_CONNECTION } from "../../lib/transport";
import { plotterMakeModel, plotterConnected, connTarget } from "../../engine/detect";
import { plotterSerial } from "./SettingsDialog";
import { useAuth } from "../../store/AuthContext";

// Toolbar plotter pill — opens the Plotter settings dialog (device list + gear settings live there).
export const PlotterMenu = () => {
  const { state, dispatch } = useWorkspace();
  const isAdmin = useAuth()?.user?.role === "admin";
  const c = { ...DEFAULT_CONNECTION, ...state.connection };
  const live = state.bridge;
  const connected = plotterConnected(c, live);
  const detected = live?.ok && connected ? plotterMakeModel(live, connTarget(c)) : "";
  const serial = live?.ok ? plotterSerial(live) : "";
  const label = !connected && !(isAdmin && c.transport === "download") ? "Connect Plotter" : c.transport === "download" ? "Cut file only" : c.transport === "bridge" ? detected || (c.targetType === "printer" ? c.printerName : c.targetType === "serial" ? c.serialPort : `${c.host}:${c.port}`) || "USB Plotter" : c.transport === "webserial" ? "USB/Serial (browser)" : "USB (browser)";
  const dot = connected ? "bg-[#3ecf8e] shadow-[0_0_6px_#3ecf8e]" : c.transport === "download" ? "bg-[#9aa0a8]" : live ? "bg-[#f5a524]" : "bg-[#2f80ff]";

  return (
    <button data-testid="machine-status-pill" title={live ? "Plotter settings" : "Set up the shop computer"} onClick={() => dispatch({ type: "SET", patch: { dialog: "settings" } })} className="mr-1 flex items-center gap-2 rounded-md border border-[#27324a] bg-[#0c1017] px-2.5 py-1 text-[12px] transition-colors hover:bg-[#1a2231]">
      <span className={`h-2 w-2 rounded-full ${dot}`} />
      <span className="hidden text-[#9aa0a8] 2xl:inline">Plotter:</span><span className="max-w-[96px] truncate 2xl:max-w-[220px]" data-testid="plotter-pill-label">{label}{serial && <span className="ml-1 font-mono text-[10px] text-[#9aa0a8]" data-testid="plotter-pill-serial">SN {serial}</span>}</span>
      <Settings className="h-3.5 w-3.5 text-[#9aa0a8]" />
    </button>
  );
};
